import React, { Component } from 'react';

import { View, ScrollView, StyleSheet } from 'react-native';
import { themeColors } from '../uiold/Constants';
import LoadingIndicator from '../uiold/LoadingIndicator';

type HeaderProps = {
  children?: React.ReactNode;
  noline: boolean;
  style?: StyleSet;
};

type BodyProps = {
  children?: React.ReactNode;
  style?: StyleSet;
};

type FooterProps = {
  children?: React.ReactNode;
  style?: StyleSet;
};

type Props = {
  isLoading: boolean;
  children?: React.ReactNode;
  style?: StyleSet;
};

type FormPageProps = {
  children?: React.ReactNode;
  style?: StyleSet;
};

function Header({ style, children, noline }: HeaderProps) {
  return (
    <View style={[styles.header, style]}>
      {children}
      {!noline && <View style={styles.underline} />}
    </View>
  );
}

Header.defaultProps = { noline: false };

function Body({ style, children }: BodyProps) {
  return <ScrollView style={[styles.body, style]}>{children}</ScrollView>;
}

function Footer({ style, children }: FooterProps) {
  return <View style={[styles.formFooter, style]}>{children}</View>;
}

function FormPage({ style, children }: FormPageProps) {
  return <View style={[styles.root, style]}>{children}</View>;
}
class FormPageLoadingWrapper extends Component<Props> {
  static defaultProps = {
    isLoading: false,
  };

  render() {
    let { props } = this;
    return props.isLoading ? <LoadingIndicator /> : <FormPage {...props} />;
  }

  static Header = Header;
  static Body = Body;
  static Footer = Footer;
}

let styles = StyleSheet.create({
  root: {
    flex: 1,
    borderWidth: StyleSheet.hairlineWidth,
    backgroundColor: themeColors.white,
    borderColor: themeColors.withOpacity.blue50,
  },
  underline: {
    paddingTop: 10,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderColor: themeColors.withOpacity.blue50,
  },
  header: {
    padding: 20,
  },
  body: {
    height: 0,
    padding: 20,
  },
  formFooter: {
    padding: 20,
    justifyContent: 'center',
    backgroundColor: themeColors.footerBackgroundGrey,
  },
});

export default FormPageLoadingWrapper;
